import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Cargando...</div>;
}

const CustomerTableContainer = Loadable({
    loader: () => import('../../Containers/Customer/CustomerTableContainer'),
    loading: Loading,
});

const CreateCustomerContainer = Loadable({
    loader: () => import('../../Containers/Customer/CreateCustomerContainer'),
    loading: Loading,
});

const EditCustomerContainer = Loadable({
    loader: () => import('../../Containers/Customer/EditCustomerContainer'),
    loading: Loading,
});

const CustomerDetailContainer = Loadable({
    loader: () => import('../../Containers/Customer/CustomerDetailContainer'),
    loading: Loading,
});

const customerRoutes = [
    { path: '/customer/list', name: 'Administración de Clientes', component: CustomerTableContainer },
    { path: '/customer/create', exact: true, name: 'Nuevo Cliente', component: CreateCustomerContainer },
    { path: '/customer/:id/edit', exact: true, name: 'Modificar Cliente', component: EditCustomerContainer },
    { path: '/customer/:id', exact: true, name: 'Cliente', component: CustomerDetailContainer },
];

export default customerRoutes;


// WEBPACK FOOTER //
// ./src/Routes/Modules/customer.js